import { useEffect, useState } from "react";
import { Drawer, DrawerBody, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import SlotHolidayContainer from "./SlotHolidayContainer";
import type { Booking } from "@/types/Booking";

interface SlotHolidayDialogProps {
  showDialog: boolean;
  setShowDialog: (open: boolean) => void;
  booking?: Booking;
  onSuccess?: () => void;
}

const SlotHolidayDialog = ({ showDialog, setShowDialog, booking, onSuccess }: SlotHolidayDialogProps) => {
  // Use a key to force provider remount when dialog opens
  const [dialogKey, setDialogKey] = useState(0);

  useEffect(() => {
    // Increment key whenever dialog opens to force fresh provider state
    if (showDialog) {
      setDialogKey((prev) => prev + 1);
    }
  }, [showDialog]);

  const handleClose = () => {
    setShowDialog(false);
    onSuccess?.();
  };

  return (
    <>
      <Drawer open={showDialog} onOpenChange={setShowDialog}>
        <DrawerContent>
          <DrawerHeader className="text-center items-center">
            <DrawerTitle className="text-3xl">Take Slot Holiday</DrawerTitle>
            <DrawerDescription>Select the dates you wish to remove from your weekly slot booking.</DrawerDescription>
          </DrawerHeader>
          <DrawerBody>
            <SlotHolidayContainer key={dialogKey} onClose={handleClose} booking={booking} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default SlotHolidayDialog;
